import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ActiveFormState } from '../state/active-form.state';
import { Observable } from 'rxjs';
import { FormSetHasActiveForm, FormSetIsDirty, FormSetIsSubmitted, FormSetIsValid, SetFormState } from '../action/active-form.action';
import { ActiveFormStateModel } from '../interface/active-form.interface';

@Injectable({
    providedIn: 'root',
})
export class ActiveFormFacade {
    formState$: Observable<ActiveFormStateModel> = inject(Store).select(ActiveFormState.getFormState);

    constructor(private store: Store) {}

    public formSetHasActiveForm(activeForm: boolean): void {
        this.store.dispatch(new FormSetHasActiveForm(activeForm));
    }

    public formSetIsValid(isValid: boolean): void {
        this.store.dispatch(new FormSetIsValid(isValid));
    }

    public formSetIsDirty(isDirty: boolean): void {
        this.store.dispatch(new FormSetIsDirty(isDirty));
    }

    public formSetIsSubmitted(isSubmitted: boolean): void {
        this.store.dispatch(new FormSetIsSubmitted(isSubmitted));
    }

    public setFormState(state: ActiveFormStateModel): void {
        this.store.dispatch(new SetFormState(state));
    }
}
